module.exports = __webpack_public_path__ + "static/media/L (1).8a6810c9.jpg";